import React, { useContext, useState } from "react";
import { Chip } from "@mui/material";
import { useQuery } from "react-query";
import { QK } from "../../../base/qk";
import { getActionJobs } from "../../../api/services/notification";
import { formatDateField, formatTimeToAmPm } from "../../../base/FormatTime";
import { Visibility } from "@mui/icons-material";
import TableComponent from "../../TableComponent/TableComponent";
import TaskDetailsModal from "../../PopupModal/TaskDetailsModal";
import ActionConfirmModal from "../Modal/ActionConfirmModal";
import MyContext from "../../../context/MyContext";

const ActionsContent = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const jobsPerPage = 10;
  const { locationID } = useContext(MyContext);

  const { data: actionJobs, isLoading } = useQuery(
    [QK.actionJobs, currentPage, locationID],
    () => getActionJobs(currentPage, locationID),
    {
      keepPreviousData: true,
      enabled: !!currentPage || !!locationID,
    }
  );

  const totalRecords = actionJobs?.count || 0;
  const totalPages = Math.ceil(totalRecords / jobsPerPage);

  const handlePageChange = (event, page) => setCurrentPage(page);

  const handleShowTaskModal = (taskId) => {
    setSelectedTask(taskId);
    setShowTaskModal(true);
  };

  const columns = [
    {
      field: "scheduled_start",
      headerName: "Date",
      render: (value) => formatDateField(value),
    },
    {
      field: "scheduled_start",
      headerName: "Time",
      render: (value) => formatTimeToAmPm(value),
    },
    {
      field: "is_critical",
      headerName: "Status",
      render: (value) =>
        value ? (
          <Chip label="Critical Alert" color="error" size="small" />
        ) : (
          <Chip label="Outstanding" color="success" size="small" />
        ),
    },
    { field: "client_name", headerName: "Service User" },
    {
      field: "candidates",
      headerName: "Employee",
      render: (candidates) =>
        candidates &&
        candidates.length > 0 &&
        candidates.map((c) => `${c.first_name} ${c.last_name}`).join(", "),
    },
    {
      field: "visit_name",
      headerName: "Action Name",
      render: (value) => value || "N/A",
    },
  ];

  const actions = [
    {
      icon: <Visibility />,
      color: "primary",
      handler: (job) => handleShowTaskModal(job.id),
    },
  ];

  return (
    <div>
      <TableComponent
        columns={columns}
        data={actionJobs?.results || []}
        actions={actions}
        isLoading={isLoading}
        pagination={{ totalPages, currentPage }}
        onPageChange={handlePageChange}
        size="small"
      />

      <ActionConfirmModal
        open={showTaskModal}
        handleClose={() => setShowTaskModal(false)}
        jobId={selectedTask}
      />
    </div>
  );
};

export default ActionsContent;
